// @noflow
import { CompContainer, Container, Title } from './style';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { getThenConsumerText, getThenNotificationText, getWhenText } from '../common';
import { RecipeThenConsumer, RecipeThenNotify, RecipeWhen } from '../';

import ImmutablePropTypes from 'react-immutable-proptypes';
import { isDependentOn } from '~/core/utils/custom-prop-types';
import messages from '../intl';
import PropTypes from 'prop-types';
import * as React from 'react';

RecipeDetail.propTypes = {
    consumerDuration: isDependentOn(
        ['isNotification', 'templateName'],
        (_, isNotification, templateName) => !isNotification && !templateName,
        PropTypes.number
    ),
    consumerIndex: isDependentOn(
        ['isNotification'],
        (_, isNotification) => !isNotification,
        PropTypes.number.isRequired
    ),
    consumerName: isDependentOn(
        ['isNotification', 'templateName'],
        (_, isNotification, templateName) => !isNotification && !templateName,
        PropTypes.string.isRequired
    ),
    consumerPropertiesList: isDependentOn(
        ['isNotification'],
        (_, isNotification) => !isNotification,
        ImmutablePropTypes.list.isRequired
    ),
    consumerState: isDependentOn(
        ['isNotification'],
        (_, isNotification) => !isNotification,
        ImmutablePropTypes.list.isRequired
    ),
    consumerType: isDependentOn(
        ['isNotification'],
        (_, isNotification) => !isNotification,
        PropTypes.string.isRequired
    ),
    consumersList: isDependentOn(
        ['isNotification'],
        (_, isNotification) => !isNotification,
        ImmutablePropTypes.list.isRequired
    ),
    handleNotificationChange: PropTypes.func,
    intl: intlShape,
    isActive: PropTypes.bool,
    isConsumerActive: isDependentOn(
        ['isNotification'],
        (_, isNotification) => !isNotification,
        PropTypes.bool.isRequired
    ),
    isNotification: PropTypes.bool.isRequired,
    notificationOptions: ImmutablePropTypes.map,
    producerIndex: PropTypes.number.isRequired,
    producerName: isDependentOn(['templateName'], (_, templateName) => !templateName, PropTypes.string.isRequired),
    producerTrigger: isDependentOn(['templateName'], (_, templateName) => !templateName, PropTypes.string.isRequired),
    producerType: PropTypes.string.isRequired,
    producersList: ImmutablePropTypes.list,
    requireHiveLiveModal: PropTypes.bool,
    selectConsumer: isDependentOn(
        ['isNotification'],
        (_, isNotification) => !isNotification,
        PropTypes.func.isRequired
    ),
    selectProducer: PropTypes.func.isRequired,
    templateName: PropTypes.string
};

function RecipeDetail({
    consumerDuration,
    consumerState,
    consumerIndex,
    consumerName,
    consumerPropertiesList,
    consumerType,
    consumersList,
    handleNotificationChange,
    intl: { formatMessage },
    isActive,
    isConsumerActive,
    isNotification,
    notificationOptions,
    producerIndex,
    producerName,
    producerTrigger,
    producerType,
    producersList,
    selectConsumer,
    selectProducer,
    templateName
}) {
    let title;
    if (templateName) {
        title = <Title>{formatMessage(messages[templateName])}</Title>;
    } else {
        const whenText = getWhenText(formatMessage, {
            name: producerName,
            trigger: producerTrigger,
            type: producerType
        });
        const thenText = isNotification
            ? getThenNotificationText(formatMessage, notificationOptions)
            : getThenConsumerText(formatMessage, {
                  duration: consumerDuration,
                  name: consumerName,
                  state: consumerState,
                  type: consumerType
              });
        title = (
            <Title>
                {whenText}, {thenText}
            </Title>
        );
    }

    return (
        <Container>
            {title}
            <CompContainer>
                <h2>
                    <FormattedMessage {...messages.when} />
                </h2>
                <RecipeWhen
                    currentIndex={producerIndex}
                    deviceType={producerType}
                    handleSelection={selectProducer}
                    isDeviceActiveState={isActive}
                    list={producersList}
                />
            </CompContainer>
            <CompContainer hide={producerIndex === -1}>
                <h2>
                    <FormattedMessage {...messages.then} />
                </h2>
                {isNotification ? (
                    <RecipeThenNotify changeHandlers={handleNotificationChange} options={notificationOptions} />
                ) : (
                    <RecipeThenConsumer
                        deviceList={consumersList}
                        deviceType={consumerType}
                        handleDeviceSelection={selectConsumer}
                        isDeviceActiveState={isConsumerActive}
                        propertiesList={consumerPropertiesList}
                        selectedDeviceIndex={consumerIndex}
                    />
                )}
            </CompContainer>
        </Container>
    );
}

export default injectIntl(RecipeDetail);



// WEBPACK FOOTER //
// ./src/components/widgets/recipes/recipe-detail/component.js